import { render, staticRenderFns } from "./ServiceTypeModal.vue?vue&type=template&id=5aab12ea"
import script from "./ServiceTypeModal.vue?vue&type=script&lang=js"
export * from "./ServiceTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports